import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PoNotificationService } from '@po-ui/ng-components';
import { AuthService } from '../../core/auth/auth.service';
import { MenuService } from '../../core/menu/menu.service';
import { environment } from '../../../environments/environment';
import { PoButtonType } from '@po-ui/ng-components';
import { PoPageLoginRecovery } from '@po-ui/ng-templates';

@Component({
  selector: 'erpcloud-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  standalone: false,
})
export class LoginComponent {
  loading = false;  
  environmentTag = environment.production ? '' : 'Homologação';
  loginForm!: FormGroup;
  readonly PoButtonType = PoButtonType;
  themeDark: boolean = false;

  poPageLoginRecovery: PoPageLoginRecovery = {
    url: `${environment.apiUrl}/v1/security/password-recovery-request`,
    contactMail: 'suporte@devplus.com.br',
  }
  
  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private menu: MenuService,
    private router: Router,
    private toast: PoNotificationService
  ) { }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      login: ['', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
      ]],
      password: ['', Validators.required],
      remember: [false]
    });

    const savedTheme = localStorage.getItem('theme');

    if (savedTheme === 'dark') {
      this.themeDark = true;
    } else if (savedTheme === 'light') {
      this.themeDark = false;
    } else {
      // se nunca escolheu, usa o tema do sistema
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

      if (prefersDark) {
        this.themeDark = true;
      }
    }
  }

  get login() { return this.loginForm.get('login'); }
  get password() { return this.loginForm.get('password'); }

  loginSubmit(): void {
    if (this.loginForm.invalid) { this.loginForm.markAllAsTouched(); return; }

    const { login, password, remember } = this.loginForm.value;
    this.loading = true;

    this.auth.authenticate(login!, password!, 'JURI').subscribe({
      next: () => {
        if (remember) localStorage.setItem('rememberUser', login!);
        this.menu.reconstruirMenu();
        this.router.navigate(['home']);
      },
      error: () => {
        this.toast.error('Usuário ou senha inválidos');
        this.loading = false;
      }
    });
  }
}